jQuery(function ($) {

  window.form = {}

  window.form.tagifyInit = function (scope = '') {
    let $tagify = $(scope + ' .tagify-input')

    $.each($tagify, function () {

      let $this = $(this)
      let params = {
        dropdown: {
          classname: '',
          closeOnSelect: true,
          enabled: 3,
          highlightFirst: true,
          maxItems: 6,
          position: 'all',
          mode: 'select'
        },
        editTags: false
      }

      if ($this.data('max-tags'))
        params.maxTags = $this.data('max-tags')

      if ($this.data('dropdown-enabled'))
        params.dropdown.enabled = $this.data('dropdown-enabled')

      $this
        .tagify(params)
        // .on( 'input', window.form.tagifySuggest )
        .on('add focus', window.form.tagifyScroll)
        .on('add removeTag', window.form.tagifyInput)
    })
  }

  window.form.tagifyInput = function (e) {
    let $tagify = $(e.target)
    let value = e.target.value ? JSON.parse(e.target.value).map(function (tag) { return tag.value }).join(',') : ''
    $($tagify.data('target')).val(value)
  }

  // window.form.tagifySuggest = function( e, detail ) {

  //   let $this = $(this)
  //   let tagify = $this.data('tagify')
  //   let tag = detail.value

  //   // reset the whitelist
  //   tagify.settings.whitelist.length = 0

  //   // // if the tag length is less than 5 characters
  //   // if( tag.length < 3 ) return

  //   // show the loading indicator
  //   tagify
  //     .loading( true )
  //     .dropdown
  //     .hide
  //     .call( tagify )

  //   // perform an ajax call
  //   $.ajax({
  //     async: true,
  //     type: 'post',
  //     dataType: 'json',
  //     url: ajaxUrl,
  //     data: {
  //       action: 'suggest_tags',
  //       context: $this.data('context'),
  //       tag: tag
  //     },
  //     success: function( response ) {

  //       // add values to the whitelist
  //       tagify.settings.whitelist = response.output

  //       // show the suggestions
  //       tagify
  //         .loading(false)
  //         .dropdown
  //         .show
  //         .call( tagify, tag )
  //     }
  //   })
  // }

  window.form.tagifyScroll = function (e) {
    let $this = $(e.target.previousSibling)
    let $container = $this.closest('.tagify-container')

    if ($this.data('scroll'))
      $container.scrollLeft(100000)
  }
  $(window).on('load', function () {
    window.form.tagifyInit()
  })
})



// WEBPACK FOOTER //
// ./src/js/form.js